// TODO(WEB): Implement shim, or refactor to use mailto: links
export const openInbox = () => {}
export default {
  openInbox,
}
